import React from 'react';

const renderTextWithLineBreaks = (text) => {
    if (!text) return null;

    return text.split('\n').map((line, i, arr) => (
        <React.Fragment key={i}>
            {line || ' '} {/* Replace empty lines with a space to maintain height */}
            {i < arr.length - 1 && <br />}
        </React.Fragment>
    ));
};

export default renderTextWithLineBreaks;